export default __webpack_public_path__ + "static/media/checkmark.aec8365b.svg";